<template>
  <div class="card flex flex-column">
    <h2 class="flex flex-middle flex-between">
      <div class="card-title flex flex-middle">
        <span class="card-title-dot"></span>
        <img :src="$oss(`CorrosionMonitorScreen/${name}.png`)" />
        <span class="card-title-text" v-if="title">（{{ title }}）</span>
        <div class="bg"></div>
      </div>
      <el-dropdown @command="changeChannel" v-if="hasChannel">
        <span class="el-dropdown-link">
          {{ channel }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="`${index}`"
            v-for="(channel, index) in channels"
            :key="index"
            >{{ channel.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </h2>
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    hasChannel: {
      type: Boolean,
      default: false,
    },
    deviceSn: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      active: 0,
      // channel: "Q235/Q235涂层",
      // channels: [
      //   {
      //     name: "Q235/Q235涂层",
      //     index: 0,
      //   },
      //   {
      //     name: "Q235涂层/钛",
      //     index: 1,
      //   },
      //   {
      //     name: "紫铜",
      //     index: 1,
      //   },
      //   {
      //     name: "不锈钢",
      //     index: 1,
      //   },
      //   {
      //     name: "AI",
      //     index: 1,
      //   },
      // ],
      channelsMap: {
        864452066378991: [
          {
            name: "涂层1",
            index: 1,
          },
          {
            name: "涂层2",
            index: 2,
          },
          {
            name: "紫铜T2",
            index: 3,
          },
          {
            name: "不锈钢304",
            index: 4,
          },
          {
            name: "纯铝1060",
            index: 5,
          },
        ],
        864452066360668: [
          {
            name: "35VB涂层",
            index: 1,
          },
          {
            name: "XGB35NH涂层",
            index: 2,
          },
          {
            name: "35VB",
            index: 3,
          },
          {
            name: "XGB35NH",
            index: 4,
          },
          {
            name: "Q235",
            index: 5,
          },
        ],
        865661070939627: [
          {
            name: "Q420耐候钢",
            index: 1,
          },
          {
            name: "Q420耐候钢+涂层1",
            index: 2,
          },
          {
            name: "Q235碳钢+涂层1",
            index: 3,
          },
          {
            name: "Q235碳钢+涂层2",
            index: 4,
          },
          {
            name: "Q235碳钢",
            index: 5,
          },
        ],
      },
    };
  },
  computed: {
    channels() {
      return this.channelsMap[this.deviceSn] || [];
    },
    channel: {
      get() {
        return this.channels[this.active]
          ? this.channels[this.active].name
          : "";
      },
      set(val) {
        console.log(val);
      },
    },
  },

  methods: {
    changeChannel(index) {
      this.active = Number(index);
      this.channel = this.channels[index].name;
      this.$emit("changeChannel", Number(index) + 1);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/variable";

.card {
  // overflow: hidden;
  background: rgba(#052355, 0.6);
  width: 100%;
  height: 100%;
  h2 {
    margin: 0;
    padding: 0 10px;
    height: calc(100vh / 1080 * 36);
    background: #143563;
  }
  &-title {
    position: relative;
    .bg {
      position: absolute;
      top: 0;
      left: -10%;
      height: 200%;
      width: 120%;
      background: url($oss-url + "CorrosionMonitorScreen/card-title-bg.png")
        no-repeat -50% center/100% 100%;
    }
    &.gradient {
      background: linear-gradient(to bottom, #1948a8, rgba(#1948a8, 0.6));
    }
    &-dot {
      display: inline-block;
      width: calc(100vh / 1920 * 16);
      height: calc(100vh / 1920 * 16);
      background: #42c7f7;
    }
    &-text {
      font-size: 12px;
      line-height: calc(100vh / 1080 * 36);
      color: #fff;
    }
    img {
      height: calc(100vh / 1080 * 30);
      margin-left: 10px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>
